import React from 'react';
import VimeoEmbed from '../../Shared/VimeoEmbed';
import styles from './Introduction.module.scss';
import Img from 'gatsby-image'

const Introduction = (props) => {
  let videoBool = props.videoBool

  if(videoBool) {
    return (
      <div>
        <div className={`${styles.Introduction} ${styles.Video}`}>
          <div className={styles.Introduction__Wrapper}>
            <h2>{props.title}</h2>
            <p>{props.text}</p>
          </div>
          <div className={styles.Introduction__Media}>
            <VimeoEmbed
              url={props.videoLink}
              loop={false}
              autoplay={false}
              controls={true}
            />
          </div>
        </div>
        <div className={styles.spacer}></div>
      </div>
    )
  } else {
    return (
      <div>
        <div className={`${styles.Introduction} ${styles.Image}`}>
          <div className={styles.Introduction__Wrapper}>
            <h2>{props.title}</h2>
            <p>{props.text}</p>
          </div>
          <div className={styles.Introduction__Media}>
            <Img sizes={props.mediaAsset.sizes} alt={props.mediaAsset.title} />
          </div>
        </div>
        <div className={styles.spacer}></div>
      </div>
    )
  }
}

export default Introduction;



// WEBPACK FOOTER //
// ./src/components/DayInTheLife/Introduction/index.js